import { Fragment } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import ListRemittances from "./ListRemittances";

const RemittancesListWrapper = () => {

    const breadCrumb = [
        { name: 'Venta' },
        { name: 'Gestión de contratos' },
        { name: 'Remesas', href: menuRoutes.remittances.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de remesas" breadcrumb={breadCrumb} />
                <ListRemittances />
            </FiltersProvider>
        </Fragment>
    );
}

export default RemittancesListWrapper;